/**
 * 361 Sleep — Homepage timeline lists (Vision + Trust)
 * Same rail / cream-dot / stagger animation as the mask Audience section.
 */
(function () {
  'use strict';

  var BOOTED = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenGsap(fn) {
    if (window.gsap && window.ScrollTrigger) {
      fn(window.gsap, window.ScrollTrigger);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.gsap && window.ScrollTrigger) {
        clearInterval(timer);
        fn(window.gsap, window.ScrollTrigger);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initSection(section, gsap) {
    var card = section.querySelector('[data-home-timeline-card]');
    var title = section.querySelector('[data-home-timeline-title]');
    var lead = section.querySelector('[data-home-timeline-lead]');
    var list = section.querySelector('[data-home-timeline-list]');
    var rail = section.querySelector('[data-home-timeline-rail]');
    var items = section.querySelectorAll('[data-home-timeline-item]');
    var dots = section.querySelectorAll('[data-home-timeline-dot]');
    var texts = section.querySelectorAll('[data-home-timeline-text]');
    if (!list || !items.length) return;

    if (section._homeTimelineCtx) {
      section._homeTimelineCtx.revert();
      section._homeTimelineCtx = null;
    }

    var triggerEl = card || list;

    var ctx = gsap.context(function () {
      var mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', function () {
        gsap.set([title, lead, rail, dots, texts].filter(Boolean), { clearProps: 'all' });
        if (rail) gsap.set(rail, { scaleY: 1 });
        if (dots.length) gsap.set(dots, { scale: 1, opacity: 1 });
        if (texts.length) gsap.set(texts, { opacity: 1, x: 0 });
      });

      mm.add('(prefers-reduced-motion: no-preference)', function () {
        var count = items.length;
        var step = 0.16;
        var railDur = Math.max(0.9, count * step + 0.15);

        gsap.set(rail, { scaleY: 0, transformOrigin: 'top center' });
        gsap.set(dots, { scale: 0, opacity: 0, transformOrigin: 'center center' });
        gsap.set(texts, { opacity: 0, x: 18 });
        if (title) gsap.set(title, { opacity: 0, y: 18 });
        if (lead) gsap.set(lead, { opacity: 0, y: 14 });

        var tl = gsap.timeline({
          defaults: { ease: 'power2.out' },
          scrollTrigger: {
            trigger: triggerEl,
            start: 'top 78%',
            toggleActions: 'play none none none'
          }
        });

        if (title) {
          tl.to(title, { opacity: 1, y: 0, duration: 0.65 }, 0);
        }

        if (lead) {
          tl.to(lead, { opacity: 1, y: 0, duration: 0.55 }, 0.08);
        }

        if (rail) {
          tl.to(
            rail,
            {
              scaleY: 1,
              duration: railDur,
              ease: 'power1.inOut'
            },
            0.18
          );
        }

        if (dots.length) {
          tl.to(
            dots,
            {
              scale: 1,
              opacity: 1,
              duration: 0.42,
              ease: 'back.out(2.1)',
              stagger: step
            },
            0.28
          );
        }

        if (texts.length) {
          tl.to(
            texts,
            {
              opacity: 1,
              x: 0,
              duration: 0.55,
              ease: 'power3.out',
              stagger: step
            },
            0.34
          );
        }
      });
    }, section);

    section._homeTimelineCtx = ctx;
  }

  function boot() {
    whenGsap(function (gsap, ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      document.querySelectorAll('[data-home-timeline]').forEach(function (section) {
        initSection(section, gsap);
      });

      if (!BOOTED) {
        BOOTED = true;
        window.addEventListener(
          'load',
          function () {
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('[data-home-timeline]') && !(root.matches && root.matches('[data-home-timeline]'))) {
      return;
    }
    boot();
  });
})();
